export default "__VITE_ASSET__36eLo7NU__"